module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-learn-connect.svg?9eef15be48ab98312959000a879d0c4a";